const Footer = () => {
  return (
    <div className="fixed bottom-0 w-full text-center sm:text-left bg-blue-100 px-16 py-4 z-10">
      <div className="text-xs text-primary-blue">
        © Copyright {new Date().getFullYear()} by ElectionSource. All Rights Reserved
      </div>
    </div>
  );
};

export default Footer;
